import PageBanner from "components/BannerSection/PageBanner";
import CallToSectionTwo from "components/CallToSection/CallToSectionTwo";
import HeaderOne from "components/Header/HeaderOne";
import MobileMenu from "components/Header/MobileMenu";
import Layout from "components/Layout/Layout";
import MainFooter from "components/MainFooter/MainFooter";
import Style from "components/Reuseable/Style";
import SearchPopup from "components/SearchPopup/SearchPopup";
import React from "react";
import GallerySectionFive from "components/GallerySection/GallerySectionFive";

const StaffSolutions = () => {
  return (
    <Layout pageTitle="Staff Solutions">
      <Style />
      <HeaderOne />
      <MobileMenu />
      <SearchPopup />
      <PageBanner
        title="Staff Solutions"
        parent="Services"
        parentHref="/services"
      />
      <GallerySectionFive portfolio />
      <CallToSectionTwo className="alternate" />
      <MainFooter />
    </Layout>
  );
};

export default StaffSolutions;
